module.exports = __webpack_public_path__ + "img/Pronto_Logo H_blanco 1.9270cd24.png";